import CityPageTemplate from "../city-template/CityPageTemplate";
import { derryConfig } from "./data";

export default function DerryPage() {
  return <CityPageTemplate config={derryConfig} />;
}